import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  debounce,
  featuredJobs,
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  TextField,
  CircularProgress,
  Avatar,
  useMediaQuery,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";

import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import {
  _get_job_feed_list_blog_api,
  delete_live_job_feed_api,
  favourite_live_job_api,
  job_reniew_api,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import moment from "moment";
import { s3baseUri } from "../../config/config";
import JobFeedList from "./JobFeedList";
import {
  _get_job_feed_list_blog_api_without_filters,
  get_job_list_with_path,
  get_jobs_list,
} from "../../DAL/jobs/jobs";
import CustomPopoverNew from "../../components/CustomPopoverNew";
import SharePostPopup from "../../components/cards/SharePostPopup";
import CustomModalLayout from "../../components/modal/CustomModalLayout";

export default function LiveJobFeeed() {
  const navigate = useNavigate();

  const paramslocation = useLocation();
  const backUrl = paramslocation?.state?.backUrl || "";
  console.log(paramslocation, "paramslocationparamslocation");

  const [query] = useSearchParams();
  const search = query.get("search");
  const location = query.get("location");

  const params = useParams();
  const sourceSlug = params?.source_slug ? params?.source_slug : "";
  const jobTypeSlug = params?.jobtype_slug ? params?.jobtype_slug : "";
  const {
    findId,
    setBreadCrumb,
    userInfo,
    isRefresh,
    handleReportPost,
    setUpdateJobOnNotification,
  } = useIds();
  const new_valyues = {
    deleteRecordingId: null,
    deleteDialogOpen: false,
    drawerOpen: false,
    selectedCategory: null,
    image: "",
  };

  const [recordingListState, setRecordingListState] = useState(new_valyues);
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const isTablet = useMediaQuery("(max-width:768px)");
  const scrollRef = useRef(null); // Reference to the scrollable container
  const [openDetail, setOpenDetail] = useState(false);
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  const [cv, setCv] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const [openRenewConfirm, setOpenRenewConfirm] = useState(false);
  const [renewJobId, setRenewJobId] = useState(null);

  const [open, setOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState(search || "");
  const [companyModalOpen, setCompanyModalOpen] = useState(false);

  const [searchTerm, setSearchTerm] = useState(search || "");
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filterValues, setFilterValues] = useState({
    clientName: "",
    location: location || "",
    education: "",
    jobType: "",
    experience: "",
    minSalary: "",
    maxSalary: "",
    frequency: "",
    // Date filter fields
    dateFilter: "",
    startDate: "",
    endDate: "",
    last24Hours: false, // default should be false
    start_date: "",
    end_date: "",

    // ...other fields
  });

  const { pathname } = useLocation();
  const [partnersObj, setPartnersObj] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    clientName: null,
    experience_required: null,
    education: null,
    job_type: null,
    salary: null,
    education_required: null,
    location: location || "",
    jobType: null,
    experience: null,
    minSalary: null,
    maxSalary: null,
    frequency: null,
  });

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoadMoreAvailable, setIsLoadMoreAvailable] = useState(true);

  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);

  // share job State
  const [openSharePost, setOpenSharePost] = useState(null);
  const limit_per_page = 50;
  const load_more_path = `${"api/jobs/list?page=0&limit=" + limit_per_page}`;
  let icon = {
    iconBg: "var(--portal-primary-color)",
  };
  const handleCloseDrawer = () => {
    setRecordingListState((old) => ({ ...old, drawerOpen: false }));
  };
  const handleopenFilterDrawer = () => {
    setRecordingListState((old) => ({
      ...old,
      drawerOpen: true,
      selectedCategory: null,
    }));
  };
  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
  };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchInputValue("");
    setSearchTerm("");
  };
  const handleCompanyNameClick = (Job, e) => {
    e.preventDefault();
    e.stopPropagation();
    setCompanyModalData(Job?.created_by);
    setCompanyModalOpen(true);
  };

  const handleRenewJob = async (id) => {
    const response = await job_reniew_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setCategories((prev) =>
        prev.map((obj) =>
          obj._id === id
            ? {
                ...obj,
                renewalStatus: {
                  ...obj.renewalStatus,
                  canRenew: false,
                },
              }
            : obj
        )
      );
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setOpenRenewConfirm(false);
  };
  const handleRenewClick = (id) => {
    setRenewJobId(id);
    setOpenRenewConfirm(true);
  };
  const applyFilters = (e) => {
    if (e) e.preventDefault();

    // Salary range validation
    if (
      filterValues.minSalary &&
      filterValues.maxSalary &&
      Number(filterValues.minSalary) > Number(filterValues.maxSalary)
    ) {
      enqueueSnackbar("Min Salary should not be greater than Max Salary.", {
        variant: "error",
      });
      return;
    }

    // Custom date validation
    if (filterValues.dateFilter === "custom") {
      if (!filterValues.startDate || !filterValues.endDate) {
        enqueueSnackbar(
          "Start Date and End Date are required for custom date filter.",
          { variant: "error" }
        );
        return;
      }
      if (filterValues.endDate < filterValues.startDate) {
        enqueueSnackbar(
          "End Date should be greater than or equal to Start Date.",
          { variant: "error" }
        );
        return;
      }
    }

    let last24Hours = false;
    let startDate = "";
    let endDate = "";
    if (filterValues.dateFilter === "last24hours") {
      last24Hours = true;
    } else if (filterValues.dateFilter === "last3days") {
      startDate = moment().subtract(3, "days").format("YYYY-MM-DD");
      endDate = moment().format("YYYY-MM-DD");
    } else if (filterValues.dateFilter === "last7days") {
      startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
      endDate = moment().format("YYYY-MM-DD");
    } else if (filterValues.dateFilter === "last14days") {
      startDate = moment().subtract(14, "days").format("YYYY-MM-DD");
      endDate = moment().format("YYYY-MM-DD");
    } else if (filterValues.dateFilter === "custom") {
      startDate = filterValues.startDate;
      endDate = filterValues.endDate;
    }

    const filters = {
      search: searchTerm,
      clientName: filterValues.clientName,
      location: filterValues.location,
      education: filterValues.education?.slug,
      jobType: filterValues.jobType?.slug,
      experience: filterValues.experience?.slug,
      minSalary: filterValues.minSalary,
      maxSalary: filterValues.maxSalary,
      frequencySalary: filterValues.frequency,
      created_for: findId,
      // Date filter params for API
      ...(last24Hours ? { last24Hours: true } : {}),
      ...(!last24Hours && startDate ? { startDate } : {}),
      ...(!last24Hours && endDate ? { endDate } : {}),
    };
    console.log(filters, "filtersfiltersfilters");
    fetchCategories(load_more_path, searchTerm, false, findId, filters);
    setFilterDrawerOpen(false);
    // When applying filters, update appliedFilters to include dateFilter, startDate, endDate, and last24Hours
    setAppliedFilters({ ...filterValues });
  };

  const handleOpenDetail = (job, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    navigate(`/${job.source.slug}/${jobTypeSlug}/job/${job?.job_slug}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const handleCandidates = (job) => {
    navigate(
      `/${job.source.slug}/${jobTypeSlug}/job-candidates-page/${job._id}`,
      {
        state: { job },
        topic: featuredJobs,
      }
    );
  };

  const fetchCategories = async (
    path,
    search,
    loading,
    id,
    filters = {},
    pagination_type
  ) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (!path) {
      path = load_more_path;
    }

    const is_multi_page = pagination_type === "multi_page";
    if (is_multi_page) {
      setLoading(true);
    }

    const response = await get_job_list_with_path(
      sourceSlug || "",
      search || "",
      path,
      filters,
      sourceSlug ? "false" : "true"
    );
    for (let i = 0; i < response.jobs?.length; i++) {
      for (let j = 0; j < response.jobs[i].job_applicants?.length; j++) {
        if (
          userInfo?.user_id?._id === response.jobs[i]?.job_applicants[j]?.userId
        ) {
          response.jobs[i].created_by_me = true;
        }
      }
    }

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setIsLoadMoreAvailable(response.jobs.length > 0);
      setsourceId(response.created_for);

      if (loading || is_multi_page) {
        let new_array = categories.concat(response.jobs);
        if (is_multi_page) {
          setCategories(response.jobs);
        } else {
          setCategories(new_array);
        }
        // setPageNumber((prev) => prev + 1);
      } else {
        setCategories(response.jobs);
        setPageNumber(1);
      }
      setPartnersObj(response.jobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      // enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = (pagination_type, value) => {
    console.log(value, "pagination_type");
    setPageNumber(value);
    setIsLoadingMore(true);
    const custom_path = `api/jobs/list?page=${
      value - 1
    }&limit=${limit_per_page}`;
    fetchCategories(custom_path, searchTerm, true, findId, {}, pagination_type);
  };

  let login_nfo = localStorage.getItem("user");

  let user_info = login_nfo ? JSON.parse(login_nfo) : null; // Safely parse JSON if data exists

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTerm(searchInputValue);
    }, 1000);
    return () => clearTimeout(handler);
  }, [searchInputValue]);

  // useEffect for API call (already present)
  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(
          loadMorePath,
          searchTerm,
          false,
          sourceSlug,
          filterValues
        );
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchTerm, sourceSlug]);

  useEffect(() => {
    fetchCategories(
      load_more_path,
      searchTerm || search,
      false,
      "",
      filterValues
    );
  }, [isRefresh, sourceSlug, search, location]);

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(sourceSlug)}`,
        path: `${backUrl ? backUrl : "/home"}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: `/${sourceSlug || "jobs"}/${jobTypeSlug}`,
        active: true,
      },
    ]);
  }, [sourceSlug]);

  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval = null;
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(
      navigator.userAgent
    );
    const isIosMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const resetScrollToTop = () => {
      // Pause at the bottom for 3 seconds before scrolling back to top
      setIsScrolling(true);

      setTimeout(() => {
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          // Temporarily disable smooth scrolling for the reset
          scrollContainer.style.scrollBehavior = "smooth";
          scrollContainer.scrollTop = 0;

          // Trigger reflow
          void scrollContainer.offsetHeight;

          // Re-enable smooth scrolling
          setTimeout(() => {
            scrollContainer.style.scrollBehavior = "smooth";
            setIsScrolling(false);
          }, 2000);
        });
      }, 3000); // 3 second delay at the bottom before scrolling back to top
    };

    const startScroll = () => {
      scrollInterval = setInterval(
        () => {
          if (isHovered || isScrolling) return;

          const atBottom = isIosMobile
            ? Math.ceil(
                scrollContainer.scrollTop + scrollContainer.clientHeight
              ) >=
              scrollContainer.scrollHeight - 100
            : Math.ceil(
                scrollContainer.scrollTop + scrollContainer.clientHeight
              ) >=
              scrollContainer.scrollHeight - 5;

          if (atBottom && categories.length > 0) {
            // Disabled auto load more to prevent duplicate data
            resetScrollToTop(); // Wait 3 seconds then reset to top
          } else {
            // Smoother scrolling for mobile devices
            if (isMobileDevice) {
              if (isIosMobile) {
                const iosAtBottom =
                  Math.ceil(
                    scrollContainer.scrollTop + scrollContainer.clientHeight
                  ) >=
                  scrollContainer.scrollHeight - 50;
                if (iosAtBottom && !isLoadMoreAvailable) {
                  scrollContainer.scrollTop += scrollContainer.clientHeight;
                  debounce(() => {
                    resetScrollToTop();
                  }, 10);
                } else {
                  scrollContainer.scrollTop += 50;
                }
              } else {
                scrollContainer.scrollBy({
                  top: 1,
                  behavior: "smooth",
                });
              }
            } else {
              if (isSafari) {
                scrollContainer.scrollTop += 3;
              } else {
                scrollContainer.scrollTop += 1;
              }
            }
          }
        },
        isIosMobile ? 30 : 20
      );
    };

    let lastTouchTime = 0;

    const stopScrollTemporarily = () => {
      const now = Date.now();
      if (now - lastTouchTime < 300) return;
      lastTouchTime = now;

      setIsScrolling(true);
      clearInterval(scrollInterval);
    };

    const startScrollOnTouchEnd = () => {
      clearInterval(scrollInterval);
      debounce(() => {
        setIsScrolling(false);
      }, 2000);
    };

    // Set initial smooth scrolling behavior
    scrollContainer.style.scrollBehavior = "smooth";
    startScroll();

    scrollContainer.addEventListener("touchstart", stopScrollTemporarily, {
      passive: true, // Changed to true for better performance
    });
    scrollContainer.addEventListener("touchend", startScrollOnTouchEnd, {
      passive: true, // Changed to true for better performance
    });

    return () => {
      clearInterval(scrollInterval);
      scrollContainer.removeEventListener("touchstart", stopScrollTemporarily);
      scrollContainer.removeEventListener("touchend", startScrollOnTouchEnd);
    };
  }, [isHovered, categories, isScrolling, loading]);

  const MENU_OPTIONS = (job) => {
    if (job?.created_by?._id === userInfo?.profile_id) {
      let optionsArray = [];

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        });
      }

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        });
      }

      optionsArray.push({
        label: "Share Job",
        icon: "mdi:share-outline",
        handleClick: (row) => {
          handleOpenSharePost(row);
        },
      });

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.delete &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
        });
      }

      return optionsArray;

      return [
        {
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        },
        {
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row),
        },
        {
          label: "Renew Job",
          icon: "mdi:refresh",
          handleClick: (row) => {
            handleRenewClick(row._id);
          },
          isRefresh: true,
          getDisabled: (row) => !getRenewalStatus(row), // Disable if can't renew
          getTooltip: (row) =>
            !getRenewalStatus(row)
              ? "You can only renew this job after 7 days of posting."
              : "",
        },
      ];
    } else {
      return [
        {
          label: "Share Job",
          icon: "mdi:share-outline",
          handleClick: (row) => {
            handleOpenSharePost(row);
          },
        },
        {
          label: "Report Job",
          icon: "material-symbols:report-outline",
          handleClick: (row, index) => handleNavigateReportJob(row),
          color: "error",
        },
      ];
    }
  };

  const handleNavigateReportJob = (job) => {
    // if (sourceSlug) {
    //   navigate(`/${sourceSlug}/report/job/${job._id}`, {
    //     state: {
    //       backURL: `/${sourceSlug}/${jobTypeSlug}`,
    //     },
    //   });
    // } else {
    //   navigate(`/home/report/job/${job._id}`);
    // }

    handleReportPost(job, "job", handleFilterJob);
  };

  const handleFilterJob = (id) => {
    setCategories((prev) => prev.filter((item) => item._id !== id));
  };

  const getRenewalStatus = (row) => {
    if (!row?.next_renewal_date) return false;

    const renewalDate = new Date(row.next_renewal_date);
    const now = new Date();

    return renewalDate <= now; // true if arrived/passed, false otherwise
  };
  // useEffect(() => {
  //   if (!loading) {
  //     const timeoutId = setTimeout(() => {
  //       fetchCategories(loadMorePath, searchText);
  //     }, 800);
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [searchText]);

  const handleCloseDetail = () => {
    setOpenDetail(false);
    setCv(null);
  };

  // const handleOpenDetail = (job) => {
  //   setSelectedJob(job);
  //   setOpenDetail(true);
  // };

  let arr = [12, 34, 67, 12, 88, 9, 0];
  let max = arr[0];
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] > max) {
      max = arr[i];
    }
  }

  const handleBookmarkToggle = (jobId) => {
    const newBookmarkedState = !bookmarkedJobs[jobId]; // Toggle state optimistically

    setCategories((prev) => {
      return prev.map((job) => {
        if (job._id === jobId) {
          return { ...job, is_favourite: !job.is_favourite };
        }
        return job;
      });
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        // Check if the API returns a specific message
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        // Revert state in case of API failure
        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  const handleOpen = () => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }
    setOpen(true);
  };
  const handlePersonalJob = () => {
    navigate(`/${sourceSlug}/${jobTypeSlug}/my-job-post`);
  };
  const handleNavigateAppliedJobs = () => {
    navigate(`/${sourceSlug}/applied-jobs`);
  };

  const handleClose = () => {
    setEditMode(false);
    setSelectedJob(null);

    setOpen(false);
  };
  const handleOpenEditJob = (job) => {
    if (
      (userInfo.membership_type !== "free" && !userInfo?.has_transactions) ||
      !userInfo.status
    ) {
      setOpenUpgradeModal(true);
      return;
    }

    navigate(`/${job.source.slug}/edit-job/${job.job_slug}`, {
      state: { job },
    });

    // setEditMode(true);
    // setSelectedJob(job);
    // setOpen(true);
  };

  // share post state and functions
  const handleOpenSharePost = (job) => {
    setSelectedJob(job);
    setOpenSharePost(true);
  };
  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setDeleteLoading(true);

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchTerm, false, findId);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };

  const handleDelete = (row) => {
    setDeletingMemberId(row.job_slug);
    setDeleteDialogOpen(true);
  };

  // Filter drawer state

  // Filter handlers
  const handleFilterChange = (e, obj = null) => {
    const { name, value } = e.target;
    console.log(name, value, "-name");
    console.log(obj, "-name");
    // If changing dateFilter, reset last24Hours and dates accordingly
    if (name === "dateFilter") {
      setFilterValues((prev) => ({
        ...prev,
        dateFilter: value,
        last24Hours: value === "last24hours",
        startDate: value === "custom" ? prev.startDate : "",
        endDate: value === "custom" ? prev.endDate : "",
      }));
    } else {
      setFilterValues((prev) => ({ ...prev, [name]: obj ? obj : value }));
    }
  };
  const handleFilterDrawerOpen = () => setFilterDrawerOpen(true);
  const handleFilterDrawerClose = () => setFilterDrawerOpen(false);
  const handleFilterClear = () => {
    setFilterValues({
      clientName: "",
      location: "",
      education: "",
      jobType: "",
      experience: "",
      minSalary: "",
      maxSalary: "",
      frequency: "",
      // ...other fields
    });
    setAppliedFilters({
      clientName: null,
      experience: null,
      jobType: null,
      frequency: null,
      salary: null,
      education: null,
      minSalary: null,
      maxSalary: null,
    });
    setFilterDrawerOpen(false);
    fetchCategories(load_more_path, searchTerm, false, findId, {});
  };

  // Remove a specific filter chip
  const handleRemoveFilterChip = (key) => {
    const updatedFilterValues = { ...filterValues };
    const updatedAppliedFilters = { ...appliedFilters };

    if (key === "minSalary") {
      updatedFilterValues.minSalary = "";
      updatedAppliedFilters.minSalary = null;
    } else if (key === "maxSalary") {
      updatedFilterValues.maxSalary = "";
      updatedAppliedFilters.maxSalary = null;
    } else if (key === "dateFilter") {
      updatedFilterValues.dateFilter = "";
      updatedFilterValues.startDate = "";
      updatedFilterValues.endDate = "";
      updatedFilterValues.last24Hours = false;
      updatedAppliedFilters.dateFilter = null;
      updatedAppliedFilters.startDate = null;
      updatedAppliedFilters.endDate = null;
      updatedAppliedFilters.last24Hours = false;
    } else {
      updatedFilterValues[key] = "";
      updatedAppliedFilters[key] = null;
    }

    setFilterValues(updatedFilterValues);
    setAppliedFilters(updatedAppliedFilters);

    // Create filters object for API call
    const filters = {
      clientName: updatedFilterValues.clientName,
      location: updatedFilterValues.location,
      education: updatedFilterValues.education,
      jobType: updatedFilterValues.jobType,
      experience: updatedFilterValues.experience,
      minSalary: updatedFilterValues.minSalary,
      maxSalary: updatedFilterValues.maxSalary,
      frequencySalary: updatedFilterValues.frequency,
      // created_for: findId,
    };

    // Remove empty values
    Object.keys(filters).forEach((filterKey) => {
      if (!filters[filterKey] || filters[filterKey] === "") {
        delete filters[filterKey];
      }
    });

    // Make API call with updated filters
    fetchCategories(load_more_path, searchTerm, false, findId, filters);
  };

  // Helper to get filter label
  const filterLabels = {
    clientName: "Company Name",
    experience: "Experience",
    jobType: "Job Type",
    location: "Location",
    education: "Education",
    frequency: "Frequency Salary",
    // Remove minSalary and maxSalary from here, handle below
  };

  // Helper to get filter value display (can be customized)
  const getFilterValueDisplay = (key, value) => {
    if (key === "experience") {
      return value.title;
    }
    if (key === "education") {
      return value.title;
    }
    if (key === "jobType") {
      return value.title;
    }
    return value;
  };

  // Helper to render filter chips, combining minSalary/maxSalary into one
  const renderFilterChips = () => {
    const chips = [];
    // Date filter chip logic
    let last24HoursChipAdded = false;
    if (appliedFilters.dateFilter === "last24hours") {
      chips.push(
        <Chip
          key="last24hours"
          label="Last 24 hours"
          onDelete={() => handleRemoveFilterChip("dateFilter")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
      last24HoursChipAdded = true;
    }
    // Custom date range chip logic
    let customDateChipAdded = false;
    if (
      appliedFilters.dateFilter === "custom" &&
      appliedFilters.startDate &&
      appliedFilters.endDate
    ) {
      chips.push(
        <Chip
          key="customDateRange"
          label={`Date: ${appliedFilters.startDate} to ${appliedFilters.endDate}`}
          onDelete={() => handleRemoveFilterChip("dateFilter")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
      customDateChipAdded = true;
    }
    // Min Salary chip
    if (appliedFilters.minSalary) {
      chips.push(
        <Chip
          key="minSalary"
          label={`Min Salary: €${appliedFilters.minSalary}`}
          onDelete={() => handleRemoveFilterChip("minSalary")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
    }
    // Max Salary chip
    if (appliedFilters.maxSalary) {
      chips.push(
        <Chip
          key="maxSalary"
          label={`Max Salary: €${appliedFilters.maxSalary}`}
          onDelete={() => handleRemoveFilterChip("maxSalary")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
    }
    // Other chips
    Object.entries(appliedFilters)
      .filter(
        ([key, value]) =>
          value &&
          key !== "minSalary" &&
          key !== "maxSalary" &&
          key !== "dateFilter" &&
          // Prevent duplicate custom date chip and never show startDate/endDate as separate chips if custom date chip is added
          !(
            customDateChipAdded &&
            (key === "startDate" || key === "endDate")
          ) &&
          // Prevent last24Hours chip from showing as a separate chip
          !(last24HoursChipAdded && key === "last24Hours")
      )
      .forEach(([key, value]) => {
        chips.push(
          <Chip
            key={key}
            label={`${filterLabels[key] || key}: ${getFilterValueDisplay(
              key,
              value
            )}`}
            onDelete={() => handleRemoveFilterChip(key)}
            sx={{ background: "#c0cdfa", color: "#000" }}
          />
        );
      });
    // Date range chip for other date filters (not custom)
    if (
      !customDateChipAdded &&
      ["last3days", "last7days", "last14days"].includes(
        appliedFilters.dateFilter
      )
    ) {
      // Show a chip for these date filters
      let label = "";
      if (appliedFilters.dateFilter === "last3days") label = "Last 3 days";
      if (appliedFilters.dateFilter === "last7days") label = "Last 7 days";
      if (appliedFilters.dateFilter === "last14days") label = "Last 14 days";
      chips.push(
        <Chip
          key={appliedFilters.dateFilter}
          label={label}
          onDelete={() => handleRemoveFilterChip("dateFilter")}
          sx={{ background: "#c0cdfa", color: "#000" }}
        />
      );
    }
    return chips;
  };

  const handleUpdateSpecificJob = (updatedJob, setList = setCategories) => {
    console.log("updated data", updatedJob);
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setCategories);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [categories]);

  return (
    <>
      <JobFeedList
        sourceSlug={sourceSlug}
        isTablet={isTablet}
        categories={categories}
        setCategories={setCategories}
        loading={loading}
        appliedFilters={appliedFilters}
        renderFilterChips={renderFilterChips}
        handleFilterClear={handleFilterClear}
        scrollRef={scrollRef}
        lastBookElementRef={lastBookElementRef}
        loadMoreData={loadMoreData}
        isLoadingMore={isLoadingMore}
        totalPages={totalPages}
        pageNumber={pageNumber}
        handleOpenDetail={handleOpenDetail}
        handleCompanyNameClick={handleCompanyNameClick}
        s3baseUri={s3baseUri}
        userInfo={userInfo}
        bookmarkedJobs={bookmarkedJobs}
        handleBookmarkToggle={handleBookmarkToggle}
        MENU_OPTIONS={MENU_OPTIONS}
        handlePersonalJob={handlePersonalJob}
        handleOpen={handleOpen}
        handleNavigateAppliedJobs={handleNavigateAppliedJobs}
        filterDrawerOpen={filterDrawerOpen}
        handleFilterDrawerClose={handleFilterDrawerClose}
        fetchCategories={fetchCategories}
        filterValues={filterValues}
        applyFilters={applyFilters}
        handleFilterChange={handleFilterChange}
        handleRemoveFilterChip={handleRemoveFilterChip}
        companyModalOpen={companyModalOpen}
        handleCloseCompanyModal={handleCloseCompanyModal}
        companyModalData={companyModalData}
        openDetail={openDetail}
        cv={cv}
        selectedJob={selectedJob}
        setCv={setCv}
        handleCloseDetail={handleCloseDetail}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        sourceId={sourceId}
        openUpgradeModal={openUpgradeModal}
        setOpenUpgradeModal={setOpenUpgradeModal}
        openRenewConfirm={openRenewConfirm}
        setOpenRenewConfirm={setOpenRenewConfirm}
        handleRenewJob={handleRenewJob}
        renewJobId={renewJobId}
        load_more_path={load_more_path}
        findId={findId}
        searchTerm={searchTerm}
        searchInputValue={searchInputValue}
        handleInputChange={handleInputChange}
        handleFilterDrawerOpen={handleFilterDrawerOpen}
        show_des_data={show_des_data}
        handleCandidates={handleCandidates}
        setIsHovered={setIsHovered}
        deleteDialogOpen={deleteDialogOpen}
        handleDeleteMember={handleDeleteMember}
        setDeleteDialogOpen={setDeleteDialogOpen}
        deletingMemberId={deletingMemberId}
        pageTitle={"Live Jobs Feed"}
        isMyJobPost={false}
        isFavourite={false}
      />

      {openSharePost && (
        <CustomModalLayout
          open={openSharePost}
          onClose={() => setOpenSharePost(false)}
          title="Share Job"
          width="550px"
          componentToPass={
            <SharePostPopup
              postData={{
                ...selectedJob,
                _id: selectedJob.job_slug,
                description: selectedJob.job_title,
              }}
              type={"job"}
            />
          }
        />
      )}
    </>
  );
}
